const LINK_SELECTOR = 'a.kb-advanced-image-link';

const COMPANY_SUFFIXES = {
  spa: 'S.p.A.',
  srl: 'S.r.l.',
  srls: 'S.r.l.s.',
  snc: 'S.n.c.',
  sas: 'S.a.s.',
};

const formatToken = (token) => {
  const normalized = token.trim().toLowerCase();

  if (!normalized) {
    return '';
  }

  if (COMPANY_SUFFIXES[normalized]) {
    return COMPANY_SUFFIXES[normalized];
  }

  if (/^[0-9]+$/.test(normalized)) {
    return normalized;
  }

  if (normalized.length <= 3) {
    return normalized.toUpperCase();
  }

  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
};

const extractCompanyName = (anchor) => {
  try {
    const url = new URL(anchor.href, window.location.origin);
    const segments = url.pathname.split('/').filter(Boolean);
    const slug = decodeURIComponent(segments[segments.length - 1] || '');

    if (!slug) {
      return null;
    }

    const companyName = slug
      .split(/[-_]+/)
      .map(formatToken)
      .filter(Boolean)
      .join(' ')
      .replace(/\s+/g, ' ')
      .trim();

    return companyName || null;
  } catch (_error) {
    return null;
  }
};

const labelLink = (anchor) => {
  if (!(anchor instanceof HTMLAnchorElement)) {
    return;
  }

  if (anchor.dataset.a11yLabelReady === 'true') {
    return;
  }

  if (anchor.getAttribute('aria-label')?.trim()) {
    anchor.dataset.a11yLabelReady = 'true';
    return;
  }

  if (anchor.textContent.replace(/\s+/g, ' ').trim()) {
    anchor.dataset.a11yLabelReady = 'true';
    return;
  }

  const imageAlt = anchor.querySelector('img')?.getAttribute('alt')?.trim();
  if (imageAlt) {
    anchor.dataset.a11yLabelReady = 'true';
    return;
  }

  const companyName = extractCompanyName(anchor);
  if (!companyName) {
    return;
  }

  anchor.setAttribute('aria-label', `Apri la scheda di ${companyName}`);
  anchor.dataset.a11yLabelReady = 'true';
};

export const initLinkLabels = () => {
  document.querySelectorAll(LINK_SELECTOR).forEach(labelLink);

  if (document.body?.dataset.a11yLinkObserverReady === 'true') {
    return;
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) {
          return;
        }

        if (node.matches?.(LINK_SELECTOR)) {
          labelLink(node);
        }

        node.querySelectorAll?.(LINK_SELECTOR).forEach(labelLink);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  document.body.dataset.a11yLinkObserverReady = 'true';
};
